const isValidNumber = value => {
  if (value === 0) return true;
  return value != null;
};

const borderRadiusStringToObject = borderRadiusString => {
  var _borderRadiusString$m;

  const numberPattern = /\d+/g;
  const [topLeft, topRight, bottomRight, bottomLeft] = ((_borderRadiusString$m = borderRadiusString.match(numberPattern)) === null || _borderRadiusString$m === void 0 ? void 0 : _borderRadiusString$m.map(corner => isValidNumber(corner) ? corner : null)) || [];
  const hasValidRight = isValidNumber(topRight);
  const alternateLeft = hasValidRight ? topRight : topLeft;
  return {
    topLeft: Number(topLeft),
    topRight: Number(hasValidRight ? topRight : topLeft),
    bottomRight: Number(isValidNumber(bottomRight) ? bottomRight : topLeft),
    bottomLeft: Number(isValidNumber(bottomLeft) ? bottomLeft : alternateLeft)
  };
};

export { borderRadiusStringToObject };
